import { useEffect, useRef } from "react";

export const getButtonStyle = ({
  isOpen,
  isActive,
  isDisabled,
}: {
  isOpen?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
}) => {
  if (isDisabled) {
    return {
      color: "#8C8C8C",
      backgroundColor: "#E1E3E3",
      borderColor: "#C6C8C8",
    };
  }
  if (isOpen) {
    return {
      color: "#FFF",
      backgroundColor: "#0E98D0",
      borderColor: "#0E98D0",
    };
  }
  if (isActive) {
    return {
      color: "#0E98D0",
      backgroundColor: "#ECFAFF",
      borderColor: "#D0DCDF",
    };
  }

  return {
    color: "#064C68",
    backgroundColor: "white",
    borderColor: "#E0E0E0",
  };
};

export const useClickOutside = (handler: () => void, isActive = true) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        ref.current &&
        !ref.current.contains(event.target as Node) &&
        isActive
      ) {
        handler();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handler, isActive]);

  return ref;
};

export const createDownloadFileName = (name: string) => {
  const dateObj = new Date();
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}${month}${day}_${name}`;
};
